import React from 'react'
import { ContentContainer } from '../layouts/styles'
import { Router } from '../routes/Router'

export const Content: React.FC<{ fullWidth?: boolean }> = ({ fullWidth }) => {
  return (
    <ContentContainer fullWidth={fullWidth}>
      <Router />
    </ContentContainer>
  )
}

export default Content
